import { mapActions, mapGetters, mapState } from 'vuex';
import proprietaryModelForFilter from './proprietary-model-for-filter';
import WarRoomService from '@/services/WarRoomService';

export default {
  mixins: [
    proprietaryModelForFilter,
  ],
  data() {
    return {
      noPagesLabel: 'Nenhuma página proprietária adicionada ao dashboard',
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'activeDashboard',
      'getCardByItemId',
    ]),
    ...mapState('cards', [
      'allowCards',
    ]),
    ...mapState('filter', [
      'accountId',
    ]),
    ...mapState('dashboard', [
      'isStaging',
    ]),
    hasNoPagesIds() {
      return !this.pages || this.pages.length === 0;
    },
    showContent() {
      const hasPages = !this.hasNoPagesIds;
      const hasSeries = this.rawSeries;
      return hasPages && hasSeries;
    },
    card() {
      return this.getCardByItemId(this.itemId);
    },
  },
  async created() {
    if (!this.card?.props?.filterId) {
      const newCardFilter = await this.applyGlobalFilter({ card: this.card });

      this.card.props.filterId = await WarRoomService.encodeFilter({
        account_id: this.accountId,
        is_staging: this.isStaging,
        filter: JSON.stringify(newCardFilter),
      });
    }

    this.saveCards();
  },
  methods: {
    ...mapActions('dashboard', [
      'saveNewCards',
    ]),
    ...mapActions('filter', [
      'applyGlobalFilter',
    ]),
    saveCards() {
      return this.saveNewCards(this.activeDashboardCard);
    },
  },
};
